import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useReader, useTableOfContents } from './reader.js';
function flatten(entries, depth = 0) {
    return entries.flatMap((e) => [
        { label: e.label, href: e.href, depth },
        ...flatten(e.children, depth + 1),
    ]);
}
/**
 * A native `<select>` bound to the reader's table of contents — picking an
 * entry calls `goToHref`. Native on purpose: it is fully accessible and the
 * demo styles it via `data-pore-toc`. (A Radix `DropdownMenu` variant can
 * layer on top later without touching this API.)
 */
export function TableOfContents({ className, placeholder = 'Contents…', hideWhenEmpty = true, }) {
    const toc = useTableOfContents();
    const { goToHref } = useReader();
    const items = flatten(toc).filter((e) => e.href);
    if (items.length === 0 && hideWhenEmpty)
        return null;
    return (_jsxs("select", { ...(className ? { className } : {}), "data-pore-toc": true, "aria-label": "Table of contents", value: "", onChange: (e) => e.target.value && goToHref(e.target.value), children: [_jsx("option", { value: "", children: placeholder }), items.map((t, i) => (_jsxs("option", { value: t.href, children: ['  '.repeat(t.depth), t.label] }, `${t.href}-${i}`)))] }));
}
//# sourceMappingURL=table-of-contents.js.map